module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-col",
    class: [
      'el-col-' + _vm.span,
      _vm.offset ? 'el-col-offset-' + _vm.offset : '',
      _vm.pull ? 'el-col-pull-' + _vm.pull : '',
      _vm.push ? 'el-col-push-' + _vm.push : ''
    ],
    style: (_vm.style)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a0fee542!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/col/src/col.vue
// module id = 673
// module chunks = 0